import type { IBlotterItem } from 'models/IBlotterItem';

function extractTradeDate(blotterItem: IBlotterItem): string {
  if (typeof blotterItem.tradeDate === 'string') {
    return blotterItem.tradeDate.substr(0, 10).replace(/-/g, '');
  }
  return '';
}

export function sanitizeFilename(filename: string): string {
  const sanitized = filename
    .replace(/[\\/:*?]/g, '')
    .replace(/"/g, "'")
    .replace(/>/g, ']')
    .replace(/</g, '[')
    .replace(/\s/g, ' ')
    .trim();

  if (sanitized.length >= 250) {
    return sanitized.substr(0, 247) + '...';
  }

  return sanitized;
}

/**
 * Get termsheet filename for a blotter item
 *
 * @param blotterItem Blotter item
 *
 * @returns Termsheet filename
 */
export function getTermsheetFilename(blotterItem: IBlotterItem): string {
  return getDocumentFilename(blotterItem, 'TS');
}
export function getPreconfirmationFilename(blotterItem: IBlotterItem): string {
  return getDocumentFilename(blotterItem, 'PRECONF');
}
export function getMarketingMaterialsFilename(blotterItem: IBlotterItem): string {
  return getDocumentFilename(blotterItem, 'IIS');
}

function getDocumentFilename(blotterItem: IBlotterItem, documentType: string): string {
  if (!blotterItem) {
    return documentType;
  }

  const tradeDate = extractTradeDate(blotterItem);
  const fileCode = blotterItem.fileCode || '';
  const tenor = blotterItem.tenor || '';
  const currency = blotterItem.currency || '';
  const payoffType = blotterItem.product || blotterItem.productCode || blotterItem.instrumentName || '';
  const underlyings = (blotterItem.underlyings || '').split(';').join(',');
  const isinCode = blotterItem.isin || '';
  const client = blotterItem.clientName || blotterItem.selectedOnBehalfClient || '';
  const filename = `${tradeDate} ${documentType} ${fileCode} ${tenor} ${currency} ${payoffType} [${underlyings}] ${isinCode} ${client}`;

  return sanitizeFilename(filename);
}
